import { Inject, Injectable } from '@angular/core';
import { THE_DOCUMENT, MediaType } from '@core';

@Injectable({
  providedIn: 'root'
})
export class FileSaverService {

  constructor(@Inject(THE_DOCUMENT) private readonly _document: Document) { }

  public saveBlob(blob: Blob, filename: string): void {

    if (filename.length === 0) {
      return;
    }

    const window = this._document.defaultView;
    if (window === null) {
      return;
    }

    const link = this._document.createElement('a');
    if (link.download === undefined) {
      return;
    }

    // Browsers that support HTML5 download attribute
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    link.download = filename;
    link.style.display = 'none'
    this._document.body.appendChild(link);
    link.click();
    this._document.body.removeChild(link);
  }

  public saveAsCsvWithUtf8Encoding(content: string, filename: string) {
    const blob = new Blob([content], { type: MediaType.CSV_UTF8 })
    this.saveBlob(blob, filename);
  }

  public saveAsJson<T>(content: T, filename: string) {
    try {
      const contentAsString = JSON.stringify(content, null, 2);
      const blob = new Blob([contentAsString], { type: MediaType.JSON });
      this.saveBlob(blob, filename);
    } catch (error) { }
  }
}
